// extracted by mini-css-extract-plugin
export var dropdownIcon = "_k7-6";
export var imgContainer = "_k7-3";
export var menuIcon = "_k7-5";
export var pillWrapper = "_k7-2";
export var pillsContainer = "_k7-1";
export var subscriptionCard = "_k7-0";
export var subscriptionLogo = "_k7-4";